import * as React from "react";
import pureRender from "pure-render-deepcompare-decorator";
import * as classnames from "classnames";
import * as styles from "./Dynamics.scss";

export interface IDynamicsProps {
  className?: string;
}

@pureRender
export class Dynamics extends React.Component<IDynamicsProps, any> {

  constructor(props: IDynamicsProps) {
    super(props);
    this.state = {
      point: 0,
    };

    
  }

  componentDidMount(){
    let dynamics=new f2eGameUI.Task.AwardScroll({
      $element:$(this.refs.dynamics)[0],
      actID:window._CONFIG['ACTCODE'],
      presetData:window._CONFIG['RANKINGS'],
      showHead: false,
      showTime:false,
      beforeRender: (dynamics) => {
        dynamics.data.forEach(ele => {
            ele.nickname = `<span>恭喜 ${ele.nickname} 获得了 </span>`
        })
    }
    })
  }
  

  public render() {
    const { className } = this.props;
    const { point } = this.state;
    const classNameSec = classnames(styles.sec, className);
    
    return (
      <div className={classNameSec} ref="dynamics">
          
      </div>
    );
  }
}

export default Dynamics;



// WEBPACK FOOTER //
// ./src/components/Dynamics/Dynamics.tsx